<template>
  <!-- Menu icons -->
  <div class="menu-icons">
    <!-- User menu trigger - mobile: icon only, desktop: icon + username -->
    <button class="btn-user-menu" @click="toggleUserMenu" aria-label="User menu">
      <i class="bi bi-person-fill"></i>
      <span class="user-greeting d-none d-lg-inline">{{ $t('header.welcomeMessage') + currentUser?.name + $t('header.nameTitle') }}</span>
      <i class="bi bi-chevron-down d-none d-lg-inline"></i>
    </button>
    <!-- App menu icon - visible only on mobile -->
    <button class="btn-icon d-lg-none" @click="toggleAppMenu" aria-label="App menu">
      <i class="bi bi-list"></i>
    </button>
  </div>
</template>

<script setup>
import { colors } from '../../../../consts/colors';

const props = defineProps({
  currentUser: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['toggle-user-menu', 'toggle-app-menu']);

/**
 * Toggle user menu
 */
const toggleUserMenu = () => {
  emit('toggle-user-menu');
};

/**
 * Toggle app menu
 */
const toggleAppMenu = () => {
  emit('toggle-app-menu');
};
</script>

<style lang="scss" scoped>
.menu-icons {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-left: auto;

  .btn-user-menu {
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;
    color: v-bind('colors.textPrimary');
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: color 0.2s;

    .bi-person-fill {
      font-size: 20px;
    }

    .user-greeting {
      white-space: nowrap;
    }

    .bi-chevron-down {
      font-size: 12px;
    }

    &:hover {
      color: v-bind('colors.btnTextColorHover');
    }

    &:focus {
      outline: none;
    }
  }

  .btn-icon {
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;
    color: v-bind('colors.textPrimary');
    font-size: 20px;
    transition: color 0.2s;

    &:hover {
      color: v-bind('colors.btnTextColorHover');
    }

    &:focus {
      outline: none;
    }
  }
}
</style>
